export default __webpack_public_path__ + "static/media/eth.bd55b36d.png";